export default __webpack_public_path__ + "static/media/diamond_light.196a9aec.svg";